import axios from 'axios'
// import { getToken } from "@/utils/auth";
// create an axios instance
const service = axios.create({
    // withCredentials: true // send cookies when cross-domain requests
})

// request interceptor
service.interceptors.request.use(
    config => {
        // config.headers["x-dzh-token"] = getToken();
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
